// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"seo-pagination_m-1480__HQLDo","pagination":"seo-pagination_pagination__VyFuW","active":"seo-pagination_active__QulN_","disabled":"seo-pagination_disabled__DdGW1"};